import { supportedLngs } from '@app/configs/i18n';
import { LngRecord } from '@shared/types/types';

export const toLngRecord = (text: string): LngRecord => {
    return Object.fromEntries(supportedLngs.map((lang) => [lang, text]));
};
